import React, {useEffect} from 'react';
import ImageUploading, {ImageListType} from 'react-images-uploading'
import styles from './EditModuleImage.module.css'
import {InboxOutlined} from "@ant-design/icons";
import {API_UPLOADS_URL} from "../../../../../api/$api";

interface IProps {
    currentImage: string | undefined,
    setImages: any,
    images: any
}

const EditModuleImage = ({currentImage, setImages, images}: IProps) => {
    const maxNumber = 1;

    useEffect(() => {
        if (currentImage) {
            setImages([{dataURL: API_UPLOADS_URL+currentImage}])
        }
    }, [currentImage, setImages])

    const onChange = (
        imageList: ImageListType,
        addUpdateIndex: number[] | undefined
    ) => {
        // data for submit
        setImages(imageList as never[]);
    };


    return (
        <div className="App">
            <ImageUploading
                multiple={false}
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
            >
                {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps
                  }) => (
                    <div className={styles.uploaderWrapper}>

                        {!images.length && !currentImage
                            ? (
                                <div className={styles.uploadArea} style={isDragging ? {color: "red"} : undefined}
                                     onClick={onImageUpload}
                                     {...dragProps}>

                                    <InboxOutlined className={styles.uploadIcon} width={'2em'} height={'2em'}/>
                                    <p className={styles.uploadDescription}>Нажмите или перетащите файл в эту область, чтобы загрузить</p>
                                </div>
                            )
                            : null
                        }

                        {imageList.map((image, index) => {
                            return (
                                <div key={index} className={styles.imageWrapper}>
                                    <img onClick={() => onImageUpdate(index)} src={image.dataURL}
                                         className={styles.imagePreview} alt=""/>
                                    {/*<div className="image-item__btn-wrapper">*/}
                                    {/*    <button onClick={() => onImageUpdate(index)}>Update</button>*/}
                                    {/*    <button onClick={() => onImageRemove(index)}>Remove</button>*/}
                                    {/*</div>*/}
                                </div>
                            )
                        })}
                    </div>
                )}
            </ImageUploading>
        </div>
    );
}
export default EditModuleImage;